const sumToFixed = (array, decimals = 0) => {
    if (Array.isArray(array)) {
        return array.reduce((sum, entry) => sum + entry, 0).toFixed(decimals);
    }
    console.warn('[sumToFixed] passed value is not an array', array);
    return 0;
};

export {sumToFixed};
